import { forwardRef, ReactNode, useEffect, useState } from 'react';
import classnames from "classnames";
import {
    ByzzerChangeEventHandler,
    ByzzerSelect,
    WithValue,
} from '@byzzer/ui-components';
import {useApp} from '@/contexts/UserContext';

const baseClassName = 'byz-osh-category-select';

export type ByzzerOshCategorySelectProps = {
    name?: string;
    label?: ReactNode;
    onChange?: ByzzerChangeEventHandler<string[]>;
    value?: string[];
    disabledOptions?: string[];
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    maxSelections?: number;
} & OnlyRenderableIf;

export const ByzzerOshCategorySelect = forwardRef<WithValue<string[]>, ByzzerOshCategorySelectProps>( (
{
    onChange,
    name,
    label,
    className,
    disabledOptions = [],
    placeholder,
    value,
    disabled,
    onlyRenderIf,
    maxSelections,
}, ref
) => {
        const [internalValue, setInternalValue] = useState<string[]>();
        if (onlyRenderIf === false) return <></>;

        const { omniShopperCategories }  = useApp();

        useEffect(() => {
            setInternalValue(value)
        }, [value])

        return (
                <ByzzerSelect
                    ref={ref}
                    name={name}
                    className={classnames(baseClassName, className)}
                    options={omniShopperCategories}
                    disabled={disabled}
                    placeholder={placeholder}
                    label={label as any}
                    value={internalValue}
                    disabledOptions={disabledOptions}
                    onChange={onChange}
                    allowMultiple={true}
                    maxSelections={maxSelections}
                />
        );
    }
);

export default ByzzerOshCategorySelect;

ByzzerOshCategorySelect.displayName = 'ByzzerOshCategorySelect';